import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {Alert} from 'Components/Partials';
import {FormHandler, Label, Input, DatePicker, Toggle} from 'Components/Form';
import {PrimaryButton} from 'Components/Button';

import BookingItemApi from 'Services/Api/Exhibitor/BookingItem';

class UpdateBookingItem extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your booking items have been updated';

    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        const {setForm, bookingItem} = this.props;

        let form = {};

        if (bookingItem) {
            form = {
                date_only: bookingItem.date_only,
                start_date_time: bookingItem.start_date_time,
                end_date_time: bookingItem.end_date_time,
                title: bookingItem.title,
                email: bookingItem.email
            };
        } else {
            form = {
                date_only: false,
                start_date_time: new Date(),
                end_date_time: new Date(),
                title: 'Available Slot',
                email: '',
            };
        }

        setForm(form);
    }

    /**
     * @method handleSubmit
     * @param {Event} e
     */
    handleSubmit = async (e) => {
        e.preventDefault();

        const {form, setAlert, setWorking, exhibitor, bookingItem, submitCallback} = this.props;

        setWorking(true);

        let response = null;

        if (bookingItem) {
            response = await BookingItemApi.patch(bookingItem.id, form);
        } else {
            response = await BookingItemApi.post(null, {
                ...form,
                exhibitor_id: exhibitor.id
            });
        }

        if (!response.success) {
            setAlert('error', response.message, response.errors);
            setWorking(false);
            return false;
        } else {
            setAlert('success', this.success, {});
            submitCallback();
            this.props.onClose();
        }
    };

    /**
     * @method handleDelete
     */
    handleDelete = async () => {
        const {setAlert, setWorking, bookingItem, submitCallback} = this.props;

        setWorking(true);

        let response = await BookingItemApi.delete(bookingItem.id);

        setAlert('success', 'Item deleted', {});
        setWorking(false);

        submitCallback();

        this.props.onClose();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {form, handleInput, getFieldError, alert, working, bookingItem} = this.props;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    {bookingItem ? 'UPDATE' : 'ADD'} AVAILABILITY
                </ModalHeader>

                <form onSubmit={e => this.handleSubmit(e)}>
                    <ModalBody>
                        <p className="text-center mb-4">
                            Add in your available 30 minute time slots below to allow delegates to book meetings with you.
                        </p>

                        {alert && (<Alert {...alert} />)}

                        <Toggle
                            label="Date Only"
                            value={form.date_only}
                            error={getFieldError('date_only')}
                            onChange={v => handleInput('date_only', v)}
                        />

                        <DatePicker
                            containerClassName="my-4"
                            label={form.date_only ? "Start Date" : "Start Date Time"}
                            selected={form.start_date_time}
                            error={getFieldError('start_date_time')}
                            onChange={date => handleInput('start_date_time', date)}
                            showTimeSelect={!form.date_only}
                            timeIntervals={5}
                        />

                        <DatePicker
                            containerClassName="my-4"
                            label={form.date_only ? "End Date" : "End Date Time"}
                            selected={form.end_date_time}
                            error={getFieldError('end_date_time')}
                            onChange={date => handleInput('end_date_time', date)}
                            showTimeSelect={!form.date_only}
                            timeIntervals={5}
                        />

                        {/*
                        <Input
                            containerClassName="my-4"
                            label="Title"
                            type="text"
                            value={form.title}
                            onChange={v => handleInput('title', v)}
                        />
                        */}

                        <Input
                            containerClassName="my-4"
                            label="Email"
                            type="text"
                            value={form.email}
                            error={getFieldError('email')}
                            onChange={v => handleInput('email', v)}
                            labelColour="text-app-blue"
                        />
                    </ModalBody>

                    <ModalFooter alignment="center">
                        <PrimaryButton
                            text="Close"
                            onClick={this.props.onClose}
                            className="mr-2"
                        />

                        {bookingItem &&
                            <PrimaryButton
                                className="ml-2"
                                text="Delete"
                                onClick={this.handleDelete}
                                disabled={working}
                                working={working}
                            />
                        }

                        <PrimaryButton
                            className="ml-2"
                            text={bookingItem ? 'Update' : 'Submit'}
                            disabled={working}
                            working={working}
                        />
                    </ModalFooter>
                </form>
            </Modal>
        )
    }
}

export default FormHandler(UpdateBookingItem);
